<template>
  <component :is="dashboardComponent" />
</template>

<script>
import store from '@/store/store'

export default {
  name: 'DashboardWrapper',
  computed: {
    dashboardComponent() {
      const role = store.state.user?.role || localStorage.getItem('role')
      if (role === 'accountant') {
        return () => import('@/views/AccountantDashboard.vue')
      }
      return () => import('@/views/Home.vue')
    },
  },
}
</script>
